import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const MegaMenuWrapper = styled.div`
  position: absolute;
  z-index: 2;
  top: 100%; //relative to #header
  width: 100%;

  @media all and (max-width: ${layout.lg}) {
    display: none;
  }
`;

export const MegaMenuExitZone = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
  width: 100%;
  height: 100vh;
`;

interface FeaturesMegaMenuContainerProps {
  isOpen: boolean;
  maxHeight: number;
}

export const MegaMenuContainer = styled.div<FeaturesMegaMenuContainerProps>`
  z-index: 11;
  position: relative;
  overflow: hidden;
  transition:
    max-height 0.3s ease-in-out,
    opacity 0.3s ease-in-out;
  max-height: ${({ isOpen, maxHeight }) => (isOpen ? maxHeight : 0)}px;
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
`;

export const MegaMenuChildContainer = styled.div`
  display: block;
`;
